import { data } from '../../svg/Collapse/data';
import { makeIcon } from '../makeIcon';

export const Collapse = makeIcon(data, 'collapse', 'Collapse');

export default Collapse;
